import React from "react";
import { formatPoilcyDate } from "shared/dateFormat";
import { MoreVert as MoreVertIcon } from "@material-ui/icons";
export const WorkFlowListColumns = (actionPanel) => {
  return [
    {
      key: "fileNo",
      name: "fileNo",
      label: "File no.",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <span
              className={"search-items-content actionIcon"}
              style={{ color: "rgb(3, 169, 244)" }}
              onClick={() => {
                window.open(
                  `/#/app/workflow/view/${tableMeta.rowData[0]}/${tableMeta.rowData[3]}`,
                  "_blank",
                );
              }}
            >
              {" "}
              {value}
            </span>
          );
        },
      },
    },
    {
      key: "wfClassification",
      name: "wfClassification",
      label: "WF Classification",
    },
    {
      key: "formDesc",
      name: "formDesc",
      label: "Form Desc",
    },
    {
      key: "imageIndexId",
      name: "imageIndexId",
      label: "imageIndexId",
      options: {
        display: false,
      },
    },
    {
      key: "dateCreated",
      name: "dateCreated",
      label: "Date",
      options: {
        customBodyRender: (value) => {
          return <span> {formatPoilcyDate(value)}</span>;
        },
      },
    },
    {
      key: "formType",
      name: "Action",
      label: "",
      options: {
        customBodyRender: (row, tableMeta) => {
          return (
            <span>
              {" "}
              <MoreVertIcon
                className={"actionIcon"}
                onClick={(event) => actionPanel(event, row, tableMeta)}
              />
            </span>
          );
        },
        sort: false,
      },
    },
    {
      key: "indexId",
      name: "",
      label: "",
      options: {
        customBodyRender: (row, tableMeta) => {
          return <span className="d-none"></span>;
        },
        sort: false,
      },
    },

  ];
};
